import React, { useEffect } from 'react';
import { galleryImages } from '../Data/galleryImages';
import '../styles/LifeAtCompany.css';

const LifeAtCompany = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          if (entry.target.classList.contains('section-title')) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
          if (entry.target.classList.contains('gallery-item')) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'scale(1)';
          }
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.section-title, .gallery-item').forEach(el => {
      observer.observe(el);
      
      if (el.classList.contains('gallery-item')) {
        const index = Array.from(document.querySelectorAll('.gallery-item')).indexOf(el);
        el.style.transitionDelay = `${index * 0.1}s`;
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="life-at-company">
      <div className="section-container">
        <div className="section-title">
          <h2>Life at Dr. BhuPat Pharma</h2>
          <p>Our culture fosters collaboration, innovation, and personal growth.</p>
           <p>
                      Experience our dynamic work culture where innovation meets excellence. 
                      Join us in our mission to create breakthrough healthcare solutions 
                      that improve lives worldwide.
                    </p>
        </div>
        
        <div className="gallery">
          {galleryImages.map((image, index) => (
            <div key={index} className="gallery-item">
              <img src={image.url} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifeAtCompany;